import Vue from 'vue'
import ElementUI from 'element-ui'
import './../element-variables.scss'
import locale from 'element-ui/lib/locale/lang/ua'
Vue.use(ElementUI, { locale })
